<div mat-dialog-title>
  <div class="flex-row">
    <h3 class="flex-grow">{{ data.title }}</h3>
    <button mat-dialog-close class="no-border-button">
      <span class="material-icons-outlined"> close </span>
    </button>
  </div>
</div>
<div class="msg-body" mat-dialog-content>
  @if (data.description) {
  <p class="tooltip-description">{{ data.description }}</p>
  } @if (normalizedItems.length && isOrdered) {
  <ol class="tooltip-list" role="list">
    <ng-container *ngTemplateOutlet="listItems"></ng-container>
  </ol>
  } @else if (normalizedItems.length) {
  <ul class="tooltip-list" role="list">
    <ng-container *ngTemplateOutlet="listItems"></ng-container>
  </ul>
  }
</div>

<ng-template #listItems>
  @for (item of normalizedItems; track $index) {
  <li class="tooltip-list-item">
    <span class="tooltip-list-marker" [attr.aria-hidden]="item.generated || null">{{ item.marker }}</span>
    <span class="tooltip-list-text">{{ item.text }}</span>
  </li>
  }
</ng-template>
